const METER_RANGE = {
    MONTH: 'month',
    QUARTER: 'quarter',
    YEAR: 'year',
};
const METER_RANGE_URL_KEY = 'meter_range';
const METER_RANGE_DEFAULT = METER_RANGE.MONTH;

export { METER_RANGE, METER_RANGE_URL_KEY, METER_RANGE_DEFAULT };
